<template>
  <div class="background-main">
    <v-container
      style="height: 100%;">
      <v-row 
        style="height: 100%;"
        align="center" 
        justify="center">
        <v-col cols="12" md="4" sm="6">
          <v-card
            class="border-radius my-10"
            flat
            elevation="5"
            style="background: #ff64ad;">
            <div class="pb-6">
              <v-img
                class="ma-auto"
                contain
                height="250"
                width="250"
                alt="vuetify"
                :src="require('@/assets/image/network.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>

            <div class="px-5 py-8"
              style="background: #FFF; border-radius: 15px;">
              <div class="px-3 mb-6">
                <p class="title mb-2">
                  SAKURA
                </p>

                <p class="body-2 font-weight-light line-text-first">
                  Sistem Layanan Administrasi Kependudukan Dalam Jaringan
                </p>
              </div>

              <ValidationObserver ref="observer">
                <v-form class="text-left mb-6">
                  <ValidationProvider 
                    name="Username" 
                    rules="required" v-slot="{ errors }">
                    <v-text-field
                      v-on:keyup.enter="login"
                      disabled
                      readonly
                      outlined
                      dense
                      color="ff64ad"
                      placeholder="Username"
                      v-model="form.username"
                      v-uppercase
                      :error-messages="errors"
                      required>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Password"
                    rules="required|min:5|max:20"
                    v-slot="{ errors }">
                    <v-text-field
                      v-on:keyup.enter="login"
                      class="mt-2 mb-1"
                      outlined
                      color="ff64ad"
                      dense
                      placeholder="Password"
                      v-model="form.password"
                      :type="show ? 'text' : 'password'"
                      :counter="20"
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show = !show"
                      :error-messages="errors"
                      required>
                    </v-text-field>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div class="text-center">
                <v-alert 
                  type="error" 
                  text 
                  dense 
                  prominent 
                  v-show="message.error !== ''">
                  {{ message.error }}
                </v-alert>

                <v-btn
                  block
                  color="#ff64ad"
                  elevation="0"
                  :disabled="process.form"
                  :loading="process.form"
                  v-on:keyup.enter="login"
                  @click="login"
                  class="body-2 font-weight-bold white--text text-capitalize">
                  <v-icon size="20" class="mr-2">mdi-login-variant</v-icon>
                  Buka Kunci Layar
                </v-btn>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        list: [],
        form: {
          username: '',
          password: '',
          fcm: ''
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
    },
    methods: {
      async login () {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          this.form.fcm = this.$store.state.fcm
          
          await post('admin/auth/login', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            if (res.code === 200) {
              let user = res.data,
                  menu = []
                  
              TokenService.saveToken(
                res.data.token,
                JSON.stringify(user),
                JSON.stringify(menu)
              )

              TokenService.saveReload(false)

              TokenService.saveLockscreen(false)

              window.location = `${process.env.BASE_URL}dashboard`
            } else {
              this.process.form = false
              if (res.code === 422) {
                this.message.error = 'Kata sandi salah.'
              } else {
                this.message.error = res.message
              }
            }
          })
        }
      }
    },
    mounted() {
      this.form.username = this.user.nik || ''
    },
  }
</script>

<style>
  .background-main {
    height: 100%;
    background-image: linear-gradient(to top, #ff64ad, #ffffff);
  }
</style>